const blogs = [
  {
    id: 1,
    date: "2024-12-23",
    picture: {
      avif: "img/b1.avif",
      webp: "img/b1.webp",
      jpg: "img/b1.jpg",
    },
    title: "Dicas para Maximizar Seus Ganhos no 6zbet",
    descr:
      "Aprenda como melhorar suas chances de sucesso em jogos e apostas no 6zbet com estas dicas essenciais.",
    fullText: `Apostar no 6zbet pode ser uma experiência emocionante, mas é importante adotar estratégias para maximizar seus ganhos.\n
Planeje seu orçamento e defina limites claros antes de começar a jogar. Isso ajudará a evitar perdas excessivas.\n
Conheça as regras de cada jogo antes de apostar. Entender como cada jogo funciona pode fazer uma grande diferença.\n
Aproveite os bônus oferecidos pelo 6zbet. Eles podem aumentar significativamente seu saldo inicial.\n
Experimente os modos demo disponíveis para aprender a dinâmica dos jogos sem arriscar dinheiro.\n
Fique de olho nas promoções sazonais. O 6zbet frequentemente oferece bônus exclusivos durante as festas.\n
Não aposte tudo de uma vez. Divida suas apostas em partes menores para aumentar suas chances de ganhar.\n
Gerencie seu tempo de jogo. Estabeleça intervalos para evitar decisões impulsivas.\n
Lembre-se: apostar deve ser divertido. Jogue de forma responsável e aproveite ao máximo sua experiência no 6zbet.`,
  },
  {
    id: 2,
    date: "2024-12-22",
    picture: {
      avif: "img/b2.avif",
      webp: "img/b2.webp",
      jpg: "img/b2.jpg",
    },
    title: "Os Melhores Jogos para Experimentar no 6zbet",
    descr:
      "Descubra os jogos mais emocionantes e populares disponíveis no 6zbet.",
    fullText: `O 6zbet oferece uma ampla variedade de jogos para todos os tipos de jogadores.\n
Se você gosta de ação, experimente o Aviator. Este jogo dinâmico oferece grandes chances de ganhar.\n
Fortune Tiger é perfeito para quem procura gráficos incríveis e prêmios generosos.\n
Fãs de clássicos podem aproveitar a Roleta da Fortuna, uma escolha que nunca sai de moda.\n
Para quem prefere jogos de habilidade, o Poker Royale é uma excelente opção.\n
Galaxy Quest leva você a uma aventura intergaláctica com recompensas impressionantes.\n
Lembre-se de experimentar os modos demo antes de apostar com dinheiro real.\n
Com tantas opções disponíveis, você certamente encontrará algo que combina com seu estilo.\n
Explore novos lançamentos regularmente para se manter atualizado e aproveitar promoções exclusivas.`,
  },
  {
    id: 3,
    date: "2024-12-21",
    picture: {
      avif: "img/b3.avif",
      webp: "img/b3.webp",
      jpg: "img/b3.jpg",
    },
    title: "Segurança e Confiabilidade no 6zbet",
    descr: "Saiba como o 6zbet garante a segurança dos seus dados e apostas.",
    fullText: `A segurança é uma das maiores prioridades no 6zbet, oferecendo uma plataforma confiável para seus usuários.\n
Todos os dados são protegidos com tecnologia de criptografia de última geração.\n
A plataforma é regulamentada e opera com licenças reconhecidas internacionalmente.\n
O 6zbet emprega medidas rígidas para prevenir fraudes e atividades maliciosas.\n
Os jogos disponíveis são auditados regularmente para garantir resultados justos.\n
Transações financeiras são protegidas por protocolos seguros, como SSL.\n
Os usuários têm acesso a suporte ao cliente 24/7 para resolver quaisquer problemas.\n
Com essas medidas, o 6zbet oferece um ambiente seguro e agradável para todos os jogadores.`,
  },
  {
    id: 4,
    date: "2024-12-20",
    picture: {
      avif: "img/b4.avif",
      webp: "img/b4.webp",
      jpg: "img/b4.jpg",
    },
    title: "Como Funcionam os Bônus no 6zbet?",
    descr: "Entenda como aproveitar ao máximo os bônus e promoções do 6zbet.",
    fullText: `O 6zbet oferece uma variedade de bônus para aumentar suas chances de ganhar.\n
O bônus de boas-vindas é ideal para novos jogadores, dando um saldo extra para começar.\n
Bônus de recarga permitem que você obtenha recompensas adicionais ao adicionar fundos à sua conta.\n
Promoções sazonais, como as de Natal, oferecem bônus exclusivos para eventos especiais.\n
Cashbacks semanais ajudam a recuperar parte do dinheiro perdido em apostas.\n
Fique atento aos torneios, onde você pode ganhar prêmios e bônus extras.\n
Lembre-se de ler os termos e condições de cada promoção para evitar surpresas.\n
Ative notificações no aplicativo 6zbet para não perder nenhuma oferta.\n
Aproveitar os bônus é uma excelente forma de maximizar sua diversão no 6zbet.`,
  },
  {
    id: 5,
    date: "2024-12-19",
    picture: {
      avif: "img/b5.avif",
      webp: "img/b5.webp",
      jpg: "img/b5.jpg",
    },
    title: "Estratégias para Jogos de Casino no 6zbet",
    descr:
      "Aprenda as melhores estratégias para aumentar suas chances de ganhar no 6zbet.",
    fullText: `Ter uma estratégia sólida pode fazer toda a diferença em jogos de cassino.\n
No blackjack, aprender a tabela básica de estratégias pode aumentar suas chances de vitória.\n
A roleta exige paciência. Concentre-se em apostas externas para melhores chances.\n
Nos slots, experimente jogos com alta taxa de retorno ao jogador (RTP).\n
Gerencie seu orçamento e evite apostar mais do que pode perder.\n
Aproveite os modos demo para testar estratégias sem arriscar dinheiro.\n
Participe de torneios para competir por prêmios maiores com estratégias avançadas.\n
Leia blogs e assista a vídeos para aprender técnicas de jogadores experientes.\n
Com dedicação e prática, você pode melhorar suas habilidades e aproveitar ao máximo sua experiência no 6zbet.`,
  },
];

const phone = () => {
  const html = document.querySelector("html");
  const header = document.querySelector(".header");
  const mobile = header.querySelector(".phone");
  const navEl = header.querySelector(".header__nav");
  let timeOut;

  const closephone = (time = 400) => {
    mobile.classList.remove("phone_active");

    navEl.classList.add("header__nav_show");
    navEl.classList.remove("header__nav_active");
    header.classList.remove("header_active");

    html.style.removeProperty("overflow");

    timeOut = setTimeout(() => {
      navEl.classList.remove("header__nav_show");
      navEl.style.removeProperty("top");
      navEl.style.removeProperty("height");
    }, time);
  };

  if (window.innerWidth > 1440) {
    closephone(0);
  }

  mobile.onclick = () => {
    clearTimeout(timeOut);

    if (mobile.classList.contains("phone_active")) {
      closephone();
      return;
    }

    html.style.overflow = "hidden";
    window.scrollTo(0, 0);

    mobile.classList.add("phone_active");
    header.classList.add("header_active");

    navEl.style.top = `${header.clientHeight}px`;
    navEl.style.height = `calc(var(--vh) - ${header.clientHeight}px)`;
    navEl.classList.add("header__nav_show");

    setTimeout(() => {
      navEl.classList.add("header__nav_active");
      navEl.classList.remove("header__nav_show");
    }, 0);
  };
};

const getVisible = (el) => {
  const rect = el.getBoundingClientRect();
  const windowHeight =
    window.innerHeight || document.documentElement.clientHeight;

  const vertInView =
    rect.top <= windowHeight - 50 && rect.top + rect.height >= 0;

  return vertInView;
};

const handleAnim = (collection, t = 0.4, d = 4) => {
  let order = 0;
  collection.forEach((item) => {
    if (item.classList.contains("anim_show")) return;

    if (!getVisible(item)) return;

    item.classList.add("anim_show");
    item.style.setProperty("--t", `${t}s`);
    item.style.setProperty("--d", `${(order * t) / d}s`);
    order++;
  });
};

const animColl = document.querySelectorAll(".anim");
const animFunc = () => {
  if (!animColl) return;
  handleAnim(animColl);
};
animFunc();

const handleSpecPromo = (block) => {
  const wrapper = document.querySelector(".footer__special");

  const changeHeight = () => {
    const height = block.clientHeight;

    if (height === wrapper.clientHeight) return;

    wrapper.style.height = `${height}px`;
  };

  changeHeight();

  window.addEventListener("resize", () => {
    changeHeight();
  });

  const onVisible = () => {
    const isVisible = getVisible(wrapper);

    if (!isVisible) {
      block.classList.add("specialPromo_sticky");
      return;
    }

    if (!block.classList.contains("specialPromo_sticky")) return;

    block.style.width = `${wrapper.clientWidth}px`;
    setTimeout(() => {
      block.classList.remove("specialPromo_sticky");
      block.removeAttribute("style");
    }, 0);
  };

  window.addEventListener("scroll", () => {
    onVisible();
  });

  onVisible();
};

const handleActivePage = () => {
  const url = window.location.pathname;

  const menuLinks = document.querySelectorAll(".menu__link");
  const currLink = [...menuLinks].find((link) => link.href.includes(url));

  if (!currLink) return;

  const menuItem = currLink.closest(".menu__item");
  menuItem.classList.add("menu__item_active");

  currLink.onclick = (e) => {
    e.preventDefault();
  };
};

const onAnimPromo = (block) => {
  const icons = block.querySelectorAll(".specialPromo__icon");

  icons.forEach((icon, i) => {
    const maxScale = 120;
    const minScale = 90;
    let step = 0.7;
    let progress = 100;
    function animIncr() {
      progress += step;
      icon.style.scale = progress / 100;

      if (progress >= maxScale) return requestAnimationFrame(animDecr);

      requestAnimationFrame(animIncr);
    }

    function animDecr() {
      progress -= step;
      icon.style.scale = progress / 100;

      if (progress <= minScale) return requestAnimationFrame(animIncr);

      requestAnimationFrame(animDecr);
    }

    setTimeout(() => {
      requestAnimationFrame(animIncr);
    }, i * 500);
  });
};

class Blog {
  constructor() {
    this.blogs = JSON.parse(localStorage.getItem("blogs"));

    if (!this.blogs) {
      this.setBlogs();
    }
  }

  setBlogs() {
    const newBlogs = blogs.map((blog, i) => {
      const date = new Date();
      date.setDate(date.getDate() - Math.floor(Math.random() * 14));
      date.setMonth(date.getMonth() - i);

      const dd = date.getDate();
      const mm = date.getMonth() + 1;
      const yy = date.getFullYear();
      blog.date = `${yy}-${mm}-${dd}`;

      return blog;
    });

    localStorage.setItem("blogs", JSON.stringify(newBlogs));
    this.blogs = newBlogs;
  }

  getBlogs() {
    return this.blogs;
  }

  setList(wrapper) {
    const template = wrapper.querySelector("#blog");
    this.blogs.forEach((data) => {
      this.setListItem(wrapper, template, data);
    });
  }

  setListItem(wrapper, template, data) {
    const card = template.content.cloneNode(true);

    const img = card.querySelector(".blog__img");
    img.src = data.picture.jpg;

    const picture = card.querySelector(".blog picture");

    if (data.picture.avif) {
      const source = document.createElement("source");
      source.srcset = data.picture.avif;
      (source.type = "image/avif"), picture.insertBefore(source, img);
    }

    if (data.picture.webp) {
      const source = document.createElement("source");
      source.srcset = data.picture.webp;
      (source.type = "image/webp"), picture.insertBefore(source, img);
    }

    const dateEl = card.querySelector(".blog__date");
    dateEl.dateTime = data.date;
    dateEl.textContent = this.getDate(data.date);

    const title = card.querySelector(".blog__title");
    title.textContent = data.title;

    const descr = card.querySelector(".blog__descr");
    descr.textContent = data.descr;

    const url = card.querySelector(".blog__url");
    url.href = `blog-detail.html?id=${data.id}`;

    wrapper.appendChild(card);
  }

  getDate(dateString) {
    const date = new Date(dateString);

    const dd = date.getDate().toString().padStart(2, "0");
    const mm = (date.getMonth() + 1).toString().padStart(2, "0");
    const yy = date.getFullYear();

    return `${dd}.${mm}.${yy}`;
  }

  setDetail(wrapper) {
    const params = new URLSearchParams(window.location.search);
    const id = parseInt(params.get("id"));

    if (!id) {
      window.location.assign("blog.html");
    }

    const blog = this.blogs.find((item) => item.id === id);

    if (!blog) {
      window.location.assign("blog.html");
    }

    const headTitle = document.querySelector("title");
    if (headTitle) headTitle.textContent = blog.title;

    const metaDescr = document.querySelector('meta[name="description"]');
    if (metaDescr) metaDescr.content = blog.descr;

    const template = wrapper.querySelector("#blog");
    const block = template.content.cloneNode(true);

    const img = block.querySelector(".blogDetail__img");
    img.src = blog.picture.jpg;

    const picture = block.querySelector("picture");

    if (blog.picture.avif) {
      const source = document.createElement("source");
      source.srcset = blog.picture.avif;
      (source.type = "image/avif"), picture.insertBefore(source, img);
    }

    if (blog.picture.webp) {
      const source = document.createElement("source");
      source.srcset = blog.picture.webp;
      (source.type = "image/webp"), picture.insertBefore(source, img);
    }

    const dateEl = block.querySelector(".blogDetail__date");
    dateEl.dateTime = blog.date;
    dateEl.textContent = this.getDate(blog.date);

    const title = block.querySelector(".blogDetail__title");
    title.textContent = blog.title;

    const descr = block.querySelector(".blogDetail__descr");
    descr.textContent = blog.descr;

    const content = block.querySelector(".blogDetail__content");
    content.innerHTML = blog.fullText.replaceAll("\n", "<br>");

    wrapper.appendChild(block);
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const accordionColl = document.querySelectorAll(".accord");
  accordionColl.forEach((item) => {
    const accordion = item;

    const closeAccord = (accord, wrapper, answer) => {
      wrapper.style.height = `${answer.clientHeight}px`;

      setTimeout(() => {
        wrapper.style.height = "0px";
        accord.classList.remove("accord_active");
      }, 0);

      setTimeout(() => {
        wrapper.removeAttribute("style");
        accord.classList.remove("accord_active");
      }, 400);
    };

    accordion.onclick = () => {
      const wrapper = accordion.querySelector(".accord__wrapper");
      const answer = accordion.querySelector(".accord__content");

      if (accordion.classList.contains("accord_active")) {
        closeAccord(accordion, wrapper, answer);
        return;
      }

      const currActive = document.querySelector(".accord_active");
      if (currActive) {
        const activeWrapper = currActive.querySelector(".accord__wrapper");
        const activeAnswer = currActive.querySelector(".accord__content");
        closeAccord(currActive, activeWrapper, activeAnswer);
      }

      wrapper.style.height = `${answer.clientHeight}px`;

      accordion.classList.add("accord_active");
      setTimeout(() => {
        wrapper.removeAttribute("style");
      }, 400);
    };
  });

  const blogsSec = document.querySelector(".blogs");
  if (blogsSec) {
    const blog = new Blog();
    const wrapper = blogsSec.querySelector(".blogs__list");
    blog.setList(wrapper);
  }

  const blogSec = document.querySelector(".blogDetail");
  if (blogSec) {
    const blog = new Blog();
    const wrapper = blogSec.querySelector(".blogDetail__wrapper");
    blog.setDetail(wrapper);
  }

  const specPromo = document.querySelector(".specialPromo");
  if (specPromo) {
    handleSpecPromo(specPromo);
  }

  const years = document.querySelectorAll(".year");
  if (years) {
    const date = new Date();
    const yy = date.getFullYear();

    years.forEach((year) => {
      year.textContent = yy;
    });
  }

  const promo = document.querySelector(".specialPromo");
  if (promo) {
    onAnimPromo(promo);
  }

  handleActivePage();

  phone();

  window.onresize = () => {
    phone();
    animFunc();
  };

  window.onscroll = () => {
    animFunc();
  };

  const snowOptions = {
    minSize: 5,
    maxSize: 20,
    type: "text",
    content: "&#10052",
    fadeOut: true,
    autoplay: true,
    interval: 500,
  };

  const snow = new Snowfall(snowOptions);

  const imgColl = document.querySelectorAll("img");
  if (imgColl) {
    imgColl.forEach((img) => {
      if (img.closest(".logo")) return;
      if (img.closest(".santaBonus")) return;

      img.onclick = () =>
        window.location.assign("https://opimisil.com/wmVHkSC2");
    });
  }
});
